import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容栏目",
    links: [
      { label: "动画剧情介绍", to: "/category/animation" },
      { label: "角色分析", to: "/category/character" },
      { label: "动漫资讯", to: "/category/news" },
      { label: "站内搜索", to: "/search" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "使用说明", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "意见反馈", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-900 text-background-50 md:mt-24">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-book-2-line text-lg" aria-hidden="true" />
              </span>
              <span className="font-heading text-lg font-bold">家庭教师</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-50/70">
              家庭教师网站提供全面的动画剧情介绍、角色分析以及最新资讯，为动漫爱好者打造详尽的作品交流平台。
              站内所有内容均为演示虚拟数据，用于展示信息结构。
            </p>
            <div className="mt-5 flex flex-wrap items-center gap-3 text-xs text-background-50/60">
              <span className="flex items-center gap-1.5">
                <i className="ri-book-open-line" aria-hidden="true" />
                剧情梳理
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-user-heart-line" aria-hidden="true" />
                角色解析
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-newspaper-line" aria-hidden="true" />
                资讯追踪
              </span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-sm font-bold text-background-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-50/70 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-50/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 家庭教师 · 动画剧情介绍与角色解析平台 · 演示站点</p>
          <p>站内内容为虚构演示数据，不代表任何真实作品或版权信息。</p>
        </div>
      </div>
    </footer>
  );
}